import { TextInput } from '@inflearn/ds-react-next';
import type { MantineSize } from '@mantine/core';
import { useTranslation } from 'next-i18next';
import type { FieldErrors, UseFormRegister } from 'react-hook-form';

import ValidationMessage from '../../../../common/ValidationMessage';

export interface EmailFormValue {
  email: string;
}

export type EmailFormItemProps<T> = T extends EmailFormValue
  ? {
      register: UseFormRegister<T>;
      errors: FieldErrors<T>;
      isRequestError?: { isError: boolean; message: string };
      onInput?: () => void;
      showLabel?: boolean;
      autoFocus?: boolean;
      size?: MantineSize;
    }
  : never;

export const EmailFormItem = <T extends EmailFormValue>({
  register,
  errors,
  isRequestError,
  onInput,
  showLabel = true,
  autoFocus = false,
  size = 'md',
}: EmailFormItemProps<T>) => {
  const { t } = useTranslation();

  return (
    <TextInput
      {...register('email')}
      autoFocus={autoFocus}
      onInput={onInput}
      placeholder={t('auth.email.placeholder')}
      label={showLabel ? t('이메일') : ''}
      size={size}
      error={
        (isRequestError?.isError && <ValidationMessage message={isRequestError.message} />) ||
        (errors.email?.message && <ValidationMessage message={errors.email.message} />)
      }
    />
  );
};
